import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { logo } from "@/data/site";
import { StatusBadge } from "@/components/Bits";
import StoreButtons from "@/components/StoreButtons";

const ACCENT = {
  purple: { block: "bg-purple", text: "text-cream", chip: "bg-cream/15 text-cream" },
  turquoise: { block: "bg-turquoise", text: "text-charcoal", chip: "bg-charcoal/10 text-charcoal" },
};

export default function AppCard({ app }) {
  const a = ACCENT[app.accent] || ACCENT.purple;
  return (
    <div
      className="group flex flex-col overflow-hidden rounded-3xl border border-charcoal/10 bg-white transition-transform duration-300 hover:-translate-y-1.5 shadow-ambient"
      data-testid={`app-card-${app.slug}`}
    >
      <div className={`relative flex items-center gap-4 p-8 ${a.block} ${a.text}`}>
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white/95 shadow-sm">
          <img src={logo} alt="" className="h-11 w-11 rounded-full" />
        </div>
        <div>
          <StatusBadge status={app.status} className="bg-white/20" />
          <h3 className="mt-2 font-display text-2xl font-bold tracking-tight">{app.name}</h3>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-8">
        <p className="font-display text-xl font-semibold leading-snug text-charcoal">{app.short}</p>
        <p className="mt-3 leading-relaxed text-charcoal/70">{app.summary}</p>

        <div className="mt-6">
          <StoreButtons appSlug={app.slug} />
        </div>

        <Link
          to={app.to}
          data-testid={`app-cta-${app.slug}`}
          className="group/cta mt-8 inline-flex items-center gap-2 font-display text-lg font-bold text-purple"
        >
          {app.cta}
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover/cta:translate-x-1" />
        </Link>
      </div>
    </div>
  );
}
